const images: Record<string, string> = {
  /* eslint-disable global-require */
  poweredByExtend: require('./powered-by-extend.png'),
}

export default images
